import {createContext} from 'react';
import {type EntitlementContextType} from './types';

const defaultState: EntitlementContextType = {
  entitlements: null,
  error: null,
  refetch: () => undefined,
  isError: false,
  isLoading: true,
};

export const EntitlementsContext =
  createContext<EntitlementContextType>(defaultState);
